import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { FolderServiceProxy,FileServiceProxy, RenameDto,DeleteFileDto} from "@/service-proxies/app-v2/dnc.service-proxies";
import { Tree } from 'ant-design-vue';
import Ellipsis from '@/components/Ellipsis';
import './componentStyle.less'
const folderservice = new FolderServiceProxy();
const fileservice = new FileServiceProxy()
@Component({
  components: {
    Ellipsis
  }
})
export default class LeftTree extends Vue {
  @Ref() aTree: Tree

  treeProps = {
    replaceFields: {
      key: "key",
    },
    treeData: [],
    selectedKeys: ["0"],
    blockNode: true,
    loadedKeys: [],
    expandedKeys: []
  }
  selectRows: any = {
    key: '0',
    title: 'page_my_document',
    parentId: '0',
    id: '0',
  }
  parentId = '0'
  inputId = ''

  mounted(){
    this.getList('0')
  }
  getList(value) {
    this.treeProps.treeData = []
    this.treeProps.loadedKeys = []
    folderservice.lazyFolderList(value).then(res => {
      if (res) {
        const childrens = this.addsCopedSlots(res)
        this.treeProps.treeData = [
          {
            title: this.$t('page_my_document'),
            key: '0',
            id: '0',
            scopedSlots: { title: "customNode" },
            children: childrens
          }
        ]
        this.treeProps.expandedKeys = ['0']
        this.$emit('select', this.treeProps.selectedKeys[0])
      }
    });
  }
  handleTreeNode(e,content){
    console.log(e)
    if(e.key === '1'){
      this.addMenu()
    } else if(e.key === '2'){
      this.renameMenu(content)
    } else {
      this.deleteMenu(content)
    }
  }
  addMenu() {
    const values = { key: 'fold' }
    this.$emit('addMenu', values)
  }
  renameMenu(value) {
    this.inputId = value.id
  }
  deleteMenu(value) {
    const values = new DeleteFileDto({
      sourceIdList: [value.id]
    })
    fileservice.delete(values).then(() => {
      this.$message.success(this.$t('page_my_document_deletesucess'))
      this.loadSelectRows(this.treeProps.treeData, value.parentId)
    })
  }
  updateMenu(value) {
    this.inputId = ''
    if (value) {
      const values = new RenameDto({
        fileType: 1,
        newName: value.target.value,
        parentId: this.selectRows.parentId
      })
      fileservice.rename(this.selectRows.key, values).then(res => {
        this.$message.success(this.$t('page_my_document_renamesucess'))
        this.loadSelectRows(this.treeProps.treeData, this.selectRows.parentId)
      })
    }
  }
  onSelectadLoad(key) {
    this.switchTree(this.treeProps.treeData, key)
    this.onSelected(key,undefined)
  }
  switchTree(data, key) {
    if (data.length > 0) {
      data.forEach(item => {
        if (item.key === key[0]) {
          this.aTree.loadData(item)
        } else {
          if (item.children && item.children.length > 0) {
            this.switchTree(item.children, key)
          }
        }
      });
    }
  }
  addLoad() {
    console.log(this.aTree,'aaaaaaaaaaaaaaaaaa')
    if (this.selectRows.key === '0') {
      this.treeProps.loadedKeys = []
      this.aTree.loadData(this.treeProps.treeData[0])
    } else {
      this.aTree.loadData(this.selectRows)
    }
    this.onSelected(this.treeProps.selectedKeys,undefined)
  }
  loadSelectRows(data, key) {
    if (data.length > 0) {
      data.forEach(item => {
        if (item.key === key) {
          this.aTree.loadData(item)
          const selectedKeys = [item.key]
          this.selectRows = item
          this.onSelected(selectedKeys,undefined)
        } else {
          if (item.children && item.children.length > 0) {
            this.loadSelectRows(item.children, key)
          }
        }
      });
    }
  }
  onSelected(selectedKeys, selectedRows) {
    if (selectedRows) {
      this.selectRows = selectedRows.node.dataRef
      this.aTree.loadData(selectedRows.node)
    }
    this.treeProps.selectedKeys = selectedKeys
    this.$emit('select', selectedKeys[0])
  }
  
  onExpand(expandedKeys){
    this.treeProps.expandedKeys = expandedKeys
  }
  pushKey(data,key){
    if(data && data.length > 0){
      data.forEach(item => {
        if(item.key === key){
          if(this.treeProps.expandedKeys.indexOf(item.key) === -1){
            this.treeProps.expandedKeys.push(item.key)
            this.treeProps.loadedKeys.push(item.key)
          }
          if(item.parentId){
            this.pushKey(this.treeProps.treeData,item.parentId)
          }
        } else {
          if(item.children && item.children.length > 0){
            this.pushKey(item.children,key)
          }
        }
      });
    }
  }
  loadData(treeNode: any) {
    return new Promise((resolve) => {
      const data = treeNode.dataRef ? treeNode.dataRef : treeNode
      this.pushKey(this.treeProps.treeData,data.key)
      this.parentId = data.key
      folderservice.lazyFolderList(data.key).then(res => {
        if (res && res.length > 0) {
          data.children = this.addsCopedSlots(res)
          data.isLeaf = false
          this.treeProps.treeData = [...this.treeProps.treeData];
          resolve();
        } else {
          data.children = []
          data.isLeaf = true
          this.treeProps.treeData = [...this.treeProps.treeData];
          resolve();
        }
      });
    });
  }
  addsCopedSlots(value) {
    value.forEach(element => {
      element.title = element.name
      element.key = element.id
      element.scopedSlots = { title: "customNode" }
      element.isLeaf = false
      element.parentId = this.parentId
    });
    return value
  }
  render() {
    console.log('this.treeProps.treeData',this.treeProps.treeData)
    return (
      <a-tree
        showLine
        showIcon
        defaultExpandAll={false}
        treeData={this.treeProps.treeData}
        blockNode = {this.treeProps.blockNode}
        selectedKeys = {this.treeProps.selectedKeys}
        loadedKeys = {this.treeProps.loadedKeys}
        expandedKeys = { this.treeProps.expandedKeys}
        onSelect={this.onSelected}
        onExpand={this.onExpand}
        loadData={this.loadData}
        ref="aTree"
        scopedSlots={{
          customNode: context => (
            (context.key === this.inputId) ? 
            
            <div>
              <a-input
                size="small"
                autoFocus={true}
                defaultValue={context.title}
                onBlur={this.updateMenu}
              ></a-input>
            </div> 
            :
            <div>
              <ellipsis length={8} tooltip={true} >{context.title}</ellipsis>
              <a-dropdown>
                <a class="right-drop-down" onClick={(e) => e.stopPropagation()}>
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay" onClick={e => this.handleTreeNode(e, context)}>
                  <a-menu-item key="1">{this.$t('create_subdirectory')}</a-menu-item>
                  <a-menu-item key="2" disabled={context.key === '0'}>
                    {this.$t('rename')}
                  </a-menu-item>
                  <a-menu-item key="3" disabled={context.key === '0'}>
                    {this.$t('delete')}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>

              {context.expanded ? 
                      (context.children && context.children.length > 0 ? 
                        <a-icon  type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;'/>
                        :
                        null
                      )  
                      :
                      (context.children && context.children.length > 0 ? 
                        <a-icon  type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;'/>
                        :
                        <a-icon  type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;'/>
                      )   
                    }
            </div>
          )
        }}
      />
    )
  }
}
